export default {
    urlOld: 'http://35.223.32.104/api/',
    //url: 'https://devapiponto.nicbrain.com.br/api/'
    url: 'https://pontoapi.nicbrain.com.br/api/'
}